import gql from 'graphql-tag'

const mutation = gql`
mutation createShop($fields: ShopInputReq!) {
	cashAssist {
	  createShop(
	    fields: $fields,
	  ) {
	    id
	    mod_ver
	    name
	    regionId
	  }
	}
}
`

export default mutation
